import { Controller, useFormContext } from "react-hook-form";
import ReactGooglePlacesAutocomplete, {
  geocodeByPlaceId,
} from "react-google-places-autocomplete";

function AddressField({
  name,
  label,
  required,
  requiredText = "This field is required",
  disabled,
  validation,
  subtext,
}) {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  // const [address, setAddress] = useState("");
  const rules = {
    ...(required && { required: requiredText }),
    ...(validation && { validate: validation }),
  };

  return (
    <fieldset>
      <label>
        {label}
        {!required && <span className="label-optional"> (Optional)</span>}
      </label>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <div className="address-field">
            <ReactGooglePlacesAutocomplete
              apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
              selectProps={{
                ...field,
                value: field.value
                  ? { label: field.value, value: field.value }
                  : { label: "", value: "" },
                isDisabled: disabled,
                onChange: async (selected) => {
                  if (!selected) return field.onChange("");
                  try {
                    const results = await geocodeByPlaceId(
                      selected.value.place_id
                    );
                    field.onChange(
                      results[0]?.formatted_address || selected.label
                    );
                  } catch {
                    field.onChange(selected.label);
                  }
                },
                onInputChange: (inputValue, { action }) => {
                  if (action === "input-change") {
                    field.onChange(inputValue);
                  }
                },
                isClearable: true,
              }}
            />
          </div>
        )}
      />
      <small>{subtext}</small>
      <span className="input-error">{errors?.[name]?.message}</span>
    </fieldset>
  );
}

export default AddressField;
